<template>
  <vx-card :id="`question-card_${question.assessment.questionId}`" v-show="isCardActiveLocal" :style="{ 'background-color': question.status == 'correct' && quizType == 'graded' ? 'rgba(107, 255, 81, 0.3)' : question.status == 'answered' || quizType == 'survey' ? 'none' : 'rgba(255, 56, 56, 0.3)' }">
    <div class="vx-row">
      <div v-if="quizType == 'graded'" class="vx-col w-full">
        <p class="mb-2">{{ question.questionText }}</p>
        <ul>
          <li v-for="(option, optionIndex) in question.answers" :key="optionIndex">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="flex" style="min-height: 27px;">
                  <div style="width: calc(21px + 0.5rem)">
                    <feather-icon v-if="option.selected && option.correct" icon="CheckIcon" class="mr-2 correct-icon" svg-classes="h-6 w-6 stroke-current"></feather-icon>
                    <feather-icon v-else-if="option.selected && !option.correct" icon="XIcon" class="mr-2 wrong-icon" svg-classes="h-6 w-6 stroke-current"></feather-icon>
                  </div>
                  <ul class="flex items-left justify-left" style="word-break: break-word;">
                    <li>
                      <p :style="{'color': setOptionColor(option, optionIndex), 'font-weight': setOptionFont(option, optionIndex) }">{{ optionIndex + 1 }}.</p>
                    </li>
                    <li class="ml-2">
                      <p :style="{'color': setOptionColor(option, optionIndex), 'font-weight': setOptionFont(option, optionIndex) }">{{ option.text }}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="mt-2 vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <p><small>Max Attempts: {{ question.maxAttempts }}</small></p>
            <p><small>Used Attempts: {{ question.usedAttempts }}</small></p>
          </div>
        </div>
      </div>
      <div v-else class="vx-col w-full">
        <p class="mb-2">{{ question.questionText }}</p>
        <ul>
          <li v-for="(option, optionIndex) in question.answers" :key="optionIndex">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div>
                  <ul class="flex items-left justify-left" style="word-break: break-word;">
                    <li>
                      <p :style="{'font-weight': option.selected ? 700 : 400 }">{{ optionIndex + 1 }}.</p>
                    </li>
                    <li class="ml-2">
                      <p :style="{'font-weight': option.selected ? 700 : 400 }">{{ option.text }}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :quizType="quizType" :predefinedComments="predefinedComments"/>
  </vx-card>
</template>

<script>
  import commentView from './iSpringCommentView.vue';
  export default {
    components: {
      commentView
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      questionCardTitle: {
        type: String,
        required: false
      },
      predefinedComments: {
        type:Array,
        required: false
      },
      quizType: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        commentView: true
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      setOptionColor(option, optionIndex) {
        if(option.selected && option.correct){
          return '#28c76f';
        }
        else if(option.selected && !option.correct){
          return '#ea5455';
        }
        else if(!option.selected && option.correct){
          return '#28c76f';
        }
        else{
          return this.$store.state.theme == 'dark' ? '#c5c5c5' : 'black';
        }
      },
      setOptionFont(option, optionIndex) {
        if(option.selected && option.correct)
          return 700;
        else if(option.selected && !option.correct)
          return 700;
        else
          return 400;
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
    }
  }

</script>

<style lang="scss">

</style>
